export enum Types {
  ADD_LOGIN = 'ADD_LOGIN',
  ADD_TOKEN = 'ADD_TOKEN',
  UPDATE_ALL_CONTACTS = 'UPDATE_ALL_CONTACTS',
  WORK_CONTACT = 'WORK_CONTACT',
  WORK_CONTACT_GET = 'WORK_CONTACT_GET',
  ALL_CONTACT_LOADING = 'ALL_CONTACT_LOADING',
  TEAM_CONTACT = 'TEAM_CONTACT',
  ALL_CONTACT = 'ALL_CONTACT',
  FAV_CONTACT = 'FAV_CONTACT',
  SET_XMPP_DETAILS = 'SET_XMPP_DETAILS',
  SET_RECENT_CHAT = 'SET_RECENT_CHAT',
  RECENT_LOAD = 'RECENT_LOAD',
  UNREAD_LOAD = 'UNREAD_LOAD',
  SAVED_LOAD = 'SAVED_LOAD',
  ARCHIVE_LOAD = 'ARCHIVE_LOAD',
  SET_PINNED_CHAT = 'SET_PINNED_CHAT',
  SET_ARCHIVE_CHAT = 'SET_ARCHIVE_CHAT',
  SET_SAVED_CHAT = 'SET_SAVED_CHAT',
  SET_UNREAD_CHAT = 'SET_UNREAD_CHAT',
  OPEN_CHAT_WINDOW = 'OPEN_CHAT_WINDOW',
  OPEN_NEW_MESSAGE = 'OPEN_NEW_MESSAGE',
  GET_LINK_LIST = 'GET_LINK_LIST',
  GET_NOTES_LIST = 'GET_NOTES_LIST',
  GET_TASK_LIST = 'GET_TASK_LIST',
  GET_EVENT_LIST = 'GET_EVENT_LIST',
  GET_FILES_LIST = 'GET_FILES_LIST',
  CHAT_FILE_LOAD = 'CHAT_FILE_LOAD',
  GET_SAVED_LIST = 'GET_SAVED_LIST',
  SET_TYPING_STATUS = 'SET_TYPING_STATUS',
  EDIT_DRAFT = 'EDIT_DRAFT',
  GET_STICKERS = 'GET_STICKERS',
  STORE_ARCHIVE_MESSAGE = 'STORE_ARCHIVE_MESSAGE',
  STORE_ARCHIVE_MESSAGE_NEW = 'STORE_ARCHIVE_MESSAGE_NEW',
  CHAT_LOAD = 'CHAT_LOAD',
  FILE_LIST = 'FILE_LIST',
  FILE_UPLOAD_PROGRESS_BAR = 'FILE_UPLOAD_PROGRESS_BAR',
  EDIT_MESSAGE_WINDOW = 'EDIT_MESSAGE_WINDOW',
  REPLY_MESSAGE_WINDOW = 'REPLY_MESSAGE_WINDOW',
  SHARE_MESSAGE_WINDOW = 'SHARE_MESSAGE_WINDOW',
  OPEN_CONTACT_WINDOW = 'OPEN_CONTACT_WINDOW',
  DELETE_MESSAGE_WINDOW = 'DELETE_MESSAGE_WINDOW',
  FORWARD_MESSAGE_WINDOW = 'FORWARD_MESSAGE_WINDOW',
  SELECT_MESSAGE_ARRAY = 'SELECT_MESSAGE_ARRAY',
  LOAD_PAGINATION_MESSAGE = 'LOAD_PAGINATION_MESSAGE',
  AUDIO_RECORD_TIMER = 'AUDIO_RECORD_TIMER',
  CHAT_SEARCH_STORE = 'CHAT_SEARCH_STORE',
  SAVE_DRAFT_MESSAGE = 'SAVE_DRAFT_MESSAGE',
  SAVE_FAILED_MESSAGE = 'SAVE_FAILED_MESSAGE',
  CONTACT_SAVED_LIST = 'CONTACT_SAVED_LIST',
  CONTACT_FILES_LIST = 'CONTACT_FILES_LIST',
  CONTACT_LINK_LIST = 'CONTACT_LINK_LIST',
  SCROLL_CONTACT_LINK_LIST = 'SCROLL_CONTACT_LINK_LIST',
  CONTACT_SAVED_LOAD = 'CONTACT_SAVED_LOAD',
  CONTACT_FILE_LOAD = 'CONTACT_FILE_LOAD',
  CONTACT_LINK_LOAD = 'CONTACT_LINK_LOAD',
  CONTACT_NOTE_UPDATE = 'CONTACT_NOTE_UPDATE',
  LOADER_SAVED = 'LOADER_SAVED',
  LOADER_LINKS = 'LOADER_LINKS',
  CALL_LIST_INPUT = 'CALL_LIST_INPUT',
  USER_AGENT_REDUCER = 'USER_AGENT_REDUCER',
  UPDATDE_CONFERENCE_LIST = 'UPDATDE_CONFERENCE_LIST',
  CONFERENCE_USER_LIST = 'CONFERENCE_USER_LIST',
  UPDATDE_CONFERENCE_NEWCALL = 'UPDATDE_CONFERENCE_NEWCALL',
  INCOMING_CALL_POPUP = 'INCOMING_CALL_POPUP',
  CALL_LIST_TYPE = 'CALL_LIST_TYPE',
  UPDATDE_CALL_LIST = 'UPDATDE_CALL_LIST',
  GET_DROPBOX_FILES = 'GET_DROPBOX_FILES',
  UPDATDE_WINDOW_SLIDE = 'UPDATDE_WINDOW_SLIDE',
  UPDATE_CALL_INFO = 'UPDATE_CALL_INFO',
  CALL_MINI_WINDOW = 'CALL_MINI_WINDOW',
  CALL_END_WINDOW = 'CALL_END_WINDOW',
  SET_SELECTED_CONTACT_INFO = 'SET_SELECTED_CONTACT_INFO',
  GET_CALL_FLIP_DETAIL = 'GET_CALL_FLIP_DETAIL',
  GET_CALL_RECORD_DETAIL = 'GET_CALL_RECORD_DETAIL',
  RESPONSE_FOR_PINNED_CHAT = 'RESPONSE_FOR_PINNED_CHAT',
  RESPONSE_FOR_RECENT_CHAT = 'RESPONSE_FOR_RECENT_CHAT',
  SET_CURRENT_CHAT_USER = 'SET_CURRENT_CHAT_USER',
  REQUEST_FOR_CURRENT_CHAT = 'REQUEST_FOR_CURRENT_CHAT',
  TOAST_INFO = 'TOAST_INFO',
  SET_CALL_REDUX_CLEAR = 'SET_CALL_REDUX_CLEAR',
  GET_DIRECT_NUMBER = 'GET_DIRECT_NUMBER',
  ASR_LANGUAGES = 'ASR_LANGUAGES',
  ASR_MIC_DEFAULT = 'ASR__MIC_DEFAULT',
  ASR_SPEAKER_DEFAULT = 'ASR_SPEAKER_DEFAULT',
  VOICE_SPEAKER_DEFAULT = 'VOICE_SPEAKER_DEFAULT',
  SHOW_ERROR = 'SHOW_ERROR',
  REMOVE_CALL_LIST = "REMOVE_CALL_LIST",
  CLEAR_DETAIL_PAGE = 'CLEAR_DETAIL_PAGE',
  TRANSCRIPT_FILE_UPLOAD = 'TRANSCRIPT_FILE_UPLOAD',
  TRANSCRIPTS_ADD_KEYWORD = 'TRANSCRIPTS_ADD_KEYWORD',
  AUTOMATED_MINS_LIST_EDIT = 'AUTOMATED_MINS_LIST_EDIT',
  SHARE_TEXT = 'SHARE_TEXT',
  TRANSCRIPTS_LIST = 'TRANSCRIPTS_LIST',
  VOICE_MAIL_TRANSCRIPTS = 'VOICE_MAIL_TRANSCRIPTS',
  TRANSCRIPTS_HIGHLIGHTS = 'TRANSCRIPTS_HIGHLIGHTS',
  TRANSCRIPTS_NEWTASK = 'TRANSCRIPTS_NEWTASK',
  PROFILE_DETAIL = 'PROFILE_DETAIL',
  USER_STATUS = 'USER_STATUS',
  EMERGENCY_ADDRESS = 'EMERGENCY_ADDRESS',
  OPEN_SETTINGS = 'OPEN_SETTINGS',
  ASR_CALLING_FROM = 'ASR_CALLING_FROM',
  ASR_CLEAR_DATA = 'ASR_CLEAR_DATA',
  ASR_STATUS = 'ASR_STATUS',
  ASR_LANG_UPDATE = 'ASR_LANG_UPDATE',
  VOICE_MAIL_CAPTION = 'VOICE_MAIL_CAPTION',
  TEAM_CONTACT_NEW = 'TEAM_CONTACT_NEW',
  PRESENCE_USER_STATUS = 'PRESENCE_USER_STATUS',
  ALL_CONTACT_NEW = 'ALL_CONTACT_NEW',
  CONTACT_WINDOW_SLIDE_OPEN = 'CONTACT_WINDOW_SLIDE_OPEN',
  CHAT_WINDOW_SLIDE_OPEN = 'CHAT_WINDOW_SLIDE_OPEN',
  CONTACT_TASK_UPDATE = 'CONTACT_TASK_UPDATE',
  CONTACT_EVENT_UPDATE = 'CONTACT_EVENT_UPDATE',
  SET_CONTACT_WINDOW = 'SET_CONTACT_WINDOW',
  UPDATE_TEAM_MEMBER = 'UPDATE_TEAM_MEMBER',
  TOAST_UNDO_CLICK = "TOAST_UNDO_CLICK",
  SAVE_CHAT_MESSAGE = 'SAVE_CHAT_MESSAGE',
  FILE_CHAT_MESSAGE = 'FILE_CHAT_MESSAGE',
  UNDO_TOAST = 'UNDO_TOAST',
  TOTAL_VOICEMAIL = 'TOTAL_VOICEMAIL',
  TOTAL_RECORDINGS = 'TOTAL_RECORDINGS',
  UPDATE_CALL_STATUS = 'UPDATE_CALL_STATUS',
  CALL_POPOUT = 'CALL_POPOUT',
  TOAST_UNDO = "TOAST_UNDO",
  FAILED_CONTACT = 'FAILED_CONTACT',
  CALL_PLUS_ICON = "CALL_PLUS_ICON",

  MULTI_NEWMESSAE = 'MULTI_NEWMESSAE',
  EMPTY_CHATWINDOWDETAILS = 'EMPTY_CHATWINDOWDETAILS',
  VIEW_EVENTS_FROM_TOAST = "VIEW_EVENTS_FROM_TOAST",
  TAB_CHANGE = 'TAB_CHANGE',
  CHECK_INTERNET = "CHECK_INTERNET",
  TRANSCRIPT_MODE = "TRANSCRIPT_MODE",
  MEETING_WINDOW_STATE = 'MEETING_WINDOW_STATE',
  MEETING_HOME_STATE = 'MEETING_HOME_STATE',
  MEETING_LEFT_SIDE = 'MEETING_LEFT_SIDE',
  VIDEO_RECORDING_LIST = 'VIDEO_RECORDING_LIST',
  MOM_PAGE = 'MOM_PAGE',
  STORE_MEETING_LIST_INPUT = 'STORE_MEETING_LIST_INPUT',
  STORE_VIDEORECORDING_LIST_INPUT = 'STORE_VIDEORECORDING_LIST_INPUT',
  STORE_TEMPLATE_LIST_INPUT = 'STORE_TEMPLATE_LIST_INPUT',
  STORE_SORT_TEMPLATE_LIST_INPUT = 'STORE_SORT_TEMPLATE_LIST_INPUT',
  TEMPLATE_LIST = 'TEMPLATE_LIST',
  LEFT_SIDE_LOADER = 'LEFT_SIDE_LOADER',
  MEETING_DETAIL_PAGE = 'MEETING_DETAIL_PAGE',
  MEETING_DETAIL_CURRENT_PAGE = 'MEETING_DETAIL_CURRENT_PAGE',
  SAVED_TEMPLATE_LOADER = 'SAVED_TEMPLATE_LOADER',
  MEETING_DETAIL_PREVIOUS_PAGE = 'MEETING_DETAIL_PREVIOUS_PAGE',
  TEMPLATE_DETAIL_PAGE = 'TEMPLATE_DETAIL_PAGE',
  MEETING_CALENDAR_LIST = 'MEETING_CALENDAR_LIST',
  UPDATE_MEETING_DETAIL = 'UPDATE_MEETING_DETAIL',
  CALL_LOGS_BAR = 'CALL_LOGS_BAR',
  MODIFY_CALL_LOGS = 'MODIFY_CALL_LOGS',
  CALL_DETAIL_PAGE = 'CALL_DETAIL_PAGE',
  // STORE_CALL_LOGS_INPUT='STORE_CALL_LOGS_INPUT'
  CLEAR_CALL_PAGE = 'CLEAR_CALL_PAGE',
  CALL_HISTORY_LOADING = 'CALL_HISTORY_LOADING',
  CALL_HISTORY = 'CALL_HISTORY',
  TOTAL_COUNTS = 'TOTAL_COUNTS',
  DIV_EDITOR = 'DIV_EDITOR',
  CHECK_NAVIGATION = 'CHECK_NAVIGATION',
  OPEN_PROFILE_VIEW = 'OPEN_PROFILE_VIEW',
  UPDATE_RIGHT_WINDOOW = 'UPDATE_RIGHT_WINDOOW',
  UNDO_STEP = 'UNDO_STEP',
  TRANS_RESULT = 'TRANS_RESULT',
  MEETING_NOTIFY = 'MEETING_NOTIFY',
  MEETING_TOTAL_COUNT = 'MEETING_TOTAL_COUNT',
  ADD_CALL = 'ADD_CALL',
  TEAM_CALL_HOLD = 'TEAM_CALL_HOLD',
  SET_ACTIVE_LOGS = 'SET_ACTIVE_LOGS',
  CHAT_NOTIFICATIONS = 'CHAT_NOTIFICATIONS',
  ISNOTIFY_STATUS = 'ISNOTIFY_STATUS',
  BELL_NOTIFICATIONS_COUNT = 'BELL_NOTIFICATIONS_COUNT',
  CALL_NOTIFICATIONS = 'CALL_NOTIFICATIONS',
  MEETING_NOTIFICATIONS = 'MEETING_NOTIFICATIONS',
  TAB_CONTENT_DETAILS = 'TAB_CONTENT_DETAILS',
  CHAT_WINDOW_RESIZE = 'CHAT_WINDOW_RESIZE',
  VIDEO_PROFILE_SETTING = 'VIDEO_PROFILE_SETTING',
  VIDEO_MEET_RING_NOTIFICATION = 'VIDEO_MEET_RING_NOTIFICATION',
  CHAT_CLEAR_MESSAGE = 'CHAT_CLEAR_MESSAGE',
  ENABLE_NOTIFICATION = 'ENABLE_NOTIFICATION',
  AUDIO_NOTIFICATION = 'AUDIO_NOTIFICATION',
  VIDEO_NOTIFICATION = 'VIDEO_NOTIFICATION',
  TEAM_VALIDATION = 'TEAM_VALIDATION',
  TRANSCRIPT_PAGE = 'TRANSCRIPT_PAGE',
  NEW_TAG_MESSAGE = 'NEW_TAG_MESSAGE',
  CC_TOAST = "CC_TOAST",
  CC_TAB = 'CC_TAB',
  EDIT_MOM = 'EDIT_MOM',
  HIGHLIGHT_PAGE = 'HIGHLIGHT_PAGE',
  JENKINS_MESSAGE = 'JENKINS_MESSAGE',
  LANDING_PAGE = 'LANDING_PAGE',
  FILE_OPEN_STATE = 'FILE_OPEN_STATE',
  VIDEO_CALL_REQUEST_SENT = 'VIDEO_CALL_REQUEST_SENT',
  HISTORY_SET = 'HISTORY_SET',
  FLIP_CALL_CONNECTED ='FLIP_CALL_CONNECTED',
  MULTI_SELECT_OPTION = 'MULTI_SELECT_OPTION',
  VIDEO_CALL_REQUEST_NOTIFICATION = 'VIDEO_CALL_REQUEST_NOTIFICATION',
  CONNECTED_CALL_INFO = 'CONNECTED_CALL_INFO',
  DELETE_CONTACT = 'DELETE_CONTACT',
  DROPDOWN_NEWCHAT = 'DROPDOWN_NEWCHAT',
  TEMPORY_CONTACT_LIST = 'TEMPORY_CONTACT_LIST',
  CC='CC',
  RECORD_DETAIL_PAGE='RECORD_DETAIL_PAGE',
  REC_SHARE="REC_SHARE",
  VIDEOCALL_RING_STATUS='VIDEOCALL_RING_STATUS',
  SSO_TOKEN_CLIENT_DOMAIN='SSO_TOKEN_CLIENT_DOMAIN',
  VIDEOMEET_COUNT_STATUS="VIDEOMEET_COUNT_STATUS",
  AUDIO_CC='AUDIO_CC',
  VOICE_MAIL_LIST='VOICE_MAIL_LIST',
  VIDEO_CALL_REQ_COUNT='VIDEO_CALL_REQ_COUNT',
  TIMER_STARTED='TIMER_STARTED',
  SET_IMG_INDEX='SET_IMG_INDEX',
  STORE_CHAT_SUMMARY='STORE_CHAT_SUMMARY',
  STORE_COMPOSED_MSG='STORE_COMPOSED_MSG',
  ACTIONS_PAGE = 'ACTIONS_PAGE',
  PERFORMANCE_PAGE= 'PERFORMANCE_PAGE',
  CLIPS_LIST='CLIPS_LIST',
  AI_ASSIST='AI_ASSIST',
  SET_ARR_BUFFER='SET_ARR_BUFFER',
  PLAY_LIST = 'PLAY_LIST',
  PLAY_LIST_PAGE = 'PLAY_LIST_PAGE',
  UPDATE_PLAYLIST='UPDATE_PLAYLIST',
  PLAN_BASED_FEATURE ='PLAN_BASED_FEATURE',
  SCROLL_UNREAD='SCROLL_UNREAD',
  COUNT_VALUE = "COUNT_VALUE"
}

export enum actionTypes {
  MESSAGE_LIST = "MESSAGE_LIST",
  RECENT_MESSAGE_LIST = "RECENT_MESSAGE_LIST",
  RECENT_LOADING = 'RECENT_LOADING',
  TYPING_STATUS = "TYPING_STATUS",
  FILE_ATTACHMENTS = "FILE_ATTACHMENTS",
  UPDATE_ARCHIVEID = 'UPDATE_ARCHIVEID',
  MESSAGE_LOADING = 'MESSAGE_LOADING',
  RECENT_SAVECHAT = 'RECENT_SAVECHAT',
  PROGRESS_COMPLETE = 'PROGRESS_COMPLETE',
  SERVER_DISCONNECT = 'SERVER_DISCONNECT',
  SCROLL_POS = 'SCROLL_POS',
  DEVICE_LIST = "DEVICE_LIST",
  STARTING_SCREEN = "STARTING_SCREEN",
  FILE_TEXT_MESSAGE = 'FILE_TEXT_MESSAGE',
  EMOJI_WINDOW = 'EMOJI_WINDOW',
  MESSAGE_EXTRALIST = "MESSAGE_EXTRALIST",
  HISTORY_LOADING = "HISTORY_LOADING"
}